import React from 'react';
import DndItems from './DndItems';
import { observer } from 'mobx-react';
import { DropTarget } from 'react-dnd';
import ItemTypes from './ItemTypes';
import DndListStore from '../../stores/DndListStore';

const dndItemTarget = {
  hover(targetProps, monitor) {
    const sourceProps = monitor.getItem();
    const sourceData = sourceProps.data;
    const dndList = targetProps.dndList;

    if (!dndList.dndItems.length) {
      DndListStore.attachToDndList({
        dndList,
        dndItem: sourceData,
      });
    }
  },
};

@DropTarget(ItemTypes.DND_ITEM, dndItemTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@observer
export default class DndList extends React.Component {
  render() {
    const { connectDropTarget, dndList, ...props } = this.props;
    const { name, dndItems } = dndList;

    return connectDropTarget(
      <div {...props}>
        <div className={'dndList-header'}>
          <div>{name}</div>

        </div>
        <DndItems items={dndItems} />
      </div>
    );
  }
}

// DndList.propTypes = {
  // connectDropTarget: PropTypes.shape(),
  // dndList: PropTypes.shape({
    // name: PropTypes.string,
    // dndItems: PropTypes.shape(),
  // }),
// };



// WEBPACK FOOTER //
// ./src/components/DnD/DndList.js